export const FETCH_CONSENT = 'FETCH_CONSENT';
export const FETCH_CONSENT_SUCCESS = 'FETCH_CONSENT_SUCCESS';
export const FETCH_CONSENT_FAILURE = 'FETCH_CONSENT_FAILURE';

export const fetchConsentData = payload => ({
  type: FETCH_CONSENT,
  payload,
});

export const fetchConsentDataSuccess = ({ consentData }) => ({
  type: FETCH_CONSENT_SUCCESS,
  payload: {
    consentData,
  },
});

export const fetchConsentDataFailure = () => ({
  type: FETCH_CONSENT_FAILURE,
});

const INIT_STATE = {
  consentData: {
    header: '',
    clauses: [],
    approves: [],
  },
};

const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_CONSENT_SUCCESS:
      return {
        ...state,
        consentData: action.payload.consentData,
      };

    default:
      return state;
  }
};

export default reducer;
export const getConsentData = state => state.annualConsent.consentData;



// WEBPACK FOOTER //
// ./app/redux/annualConsent.js